import { RefreshCw } from 'lucide-react';
import { useNewVersionAvailable } from '../lib/appUpdate';

/**
 * Bandeau « nouvelle version » : l'application restée ouverte (ou remise au premier plan) pendant
 * une livraison propose de se recharger. Pas de rechargement d'office : une saisie en cours serait
 * perdue.
 */
export default function UpdateAppBanner() {
  const available = useNewVersionAvailable();
  if (!available) return null;

  return (
    <div className="bg-panel-indigo text-white" role="status">
      <div className="max-w-6xl mx-auto px-6 py-2.5 flex items-center gap-3">
        <RefreshCw size={18} className="flex-shrink-0" />
        <p className="text-sm font-medium flex-1 min-w-0">Une nouvelle version de Permio est disponible</p>
        <button
          onClick={() => window.location.reload()}
          className="flex-shrink-0 px-3 py-1.5 rounded-lg bg-white text-primary-700 text-sm font-semibold hover:bg-primary-50 transition-colors"
        >
          Mettre à jour
        </button>
      </div>
    </div>
  );
}
